module.exports = __webpack_public_path__ + "media/images/top/top-intro_bg-68caef1d30d2825c66a7be97dcf2e1b2.jpg";